module.exports = __webpack_public_path__ + "static/media/mova.17391abb.png";